<template>
    <div class="app-header-menu flex flex-row md:gap-x-12 items-center">
        <button-menu
            v-for="(item, index) in menuItems"
            :key="'header-menu-item-' + index"
            :buttonText="item.text"
            :buttonRoute="item.route"
        ></button-menu>
    </div>
</template>

<script>
import {mapState} from 'pinia';

export default {
    name: 'AppHeaderMenu',
    computed: {
        ...mapState(useStoreHeader, {
            menuItems: 'menuItems',
        }),
    },
};
</script>
